var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('spinner'),_c('core-toolbar'),_c('core-drawer'),_c('core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }